import { Box, Button, Dialog, DialogActions, DialogContentText, Grid, IconButton, Tooltip } from '@mui/material';
import CloseIcon from '@mui/icons-material/Close';
import React from 'react';

interface ConfirmationModalProps {
  open: boolean;
  onClose?: () => void;
  onConfirm?: () => void;
  onClickSecondaryButton?: () => void;
  title: any;
  description: any;
  firstDescription?: any;
  closeMessage?: string;
  confirmMesssage?: string;
  midButtonMessage?: string;
  fullWidth?: boolean;
  hiddenCloseButton?: boolean;
}

const ConfirmModal = ({
  open,
  onClose,
  onConfirm,
  onClickSecondaryButton,
  title,
  description,
  firstDescription,
  closeMessage,
  confirmMesssage,
  midButtonMessage,
  fullWidth,
  hiddenCloseButton
}: ConfirmationModalProps) => {
  // Função para evitar propagação de eventos
  const handleStopPropagation = (e: React.MouseEvent) => {
    e.stopPropagation();
  };

  // Funções wrapper para botões
  const handleClose = (e: React.MouseEvent) => {
    e.stopPropagation();
    onClose && onClose();
  };

  const handleConfirm = (e: React.MouseEvent) => {
    e.stopPropagation();
    onConfirm && onConfirm();
  };

  const handleSecondaryClick = (e: React.MouseEvent) => {
    e.stopPropagation();
    onClickSecondaryButton && onClickSecondaryButton();
  };

  return (
    <Dialog
      fullWidth={fullWidth}
      open={open}
      onClose={onClose}
      disableEnforceFocus
      aria-labelledby="modal-title"
      aria-describedby="modal-description"
      sx={{
        display: 'flex',
        flexDirection: 'column',
        '& .MuiDialog-container': {
          alignItems: 'start'
        }
      }}
      onClick={handleStopPropagation}
    >
      <Grid
        p={3}
        pb={0}
        height={'100% !important'}
        minWidth={'300px'}
        onClick={handleStopPropagation}
      >
        {/* Título do Modal */}
        <Box
          display={'flex'}
          alignItems={'center'}
          justifyContent={'space-between'}
          onClick={handleStopPropagation}
        >
          <Box onClick={handleStopPropagation}>{title}</Box>
          {!hiddenCloseButton && (
            <Tooltip title="Fechar">
              <IconButton onClick={handleClose}>
                <CloseIcon />
              </IconButton>
            </Tooltip>
          )}
        </Box>

        <Box
          sx={{ display: 'flex', justifyContent: 'center', flexDirection: 'column' }}
          onClick={handleStopPropagation}
        >
          {firstDescription && (
            <DialogContentText
              mb={1}
              style={{ opacity: 0.7 }}
              onClick={handleStopPropagation}
            >
              {firstDescription}
            </DialogContentText>
          )}
          <Box
            textAlign={'center'}
            onClick={handleStopPropagation}
          >
            {description}
          </Box>
        </Box>

        <DialogActions onClick={handleStopPropagation}>
          {closeMessage?.length ? (
            <Button
              onClick={handleClose}
              color="primary"
            >
              {closeMessage}
            </Button>
          ) : null}
          {midButtonMessage?.length ? (
            <Button
              onClick={handleSecondaryClick}
              color="secondary"
            >
              {midButtonMessage}
            </Button>
          ) : null}
          {confirmMesssage?.length ? (
            <Button
              onClick={handleConfirm}
              color="secondary"
            >
              {confirmMesssage}
            </Button>
          ) : null}
        </DialogActions>
      </Grid>
    </Dialog>
  );
};

export default ConfirmModal;
